import React, { Fragment } from "react";

import "./SizeForm.css";
import Newloader from "../../../components/Loader/NewLoader/NewLoader";
import Input from "../../../components/Form/Input/Input";
import Button from "../../../components/Button/Button";
import ImageBox from "../../../components/ImageBox/ImageBox";
import { required, length, isNumber } from "../../../util/validators";
import { generateBase64FromImage } from "../../../util/image";


const POST_FORM = {
  title: {
    value: "",
    valid: false,
    touched: false,
    errorMessage: "",
    validators: [required, length({ min: 1 })],
  },
  sort: {
    value: "",
    valid: false,
    touched: false,
    errorMessage: "",
    validators: [isNumber],
  },
};


class SizeForm extends React.Component {
  constructor(props) {
    super(props);

    this.state = {
      postForm: POST_FORM,
      formIsValid: false,
      loading: false,
    };
  }
  
  componentDidUpdate(previousProps, previousState) {
    if (previousProps.editingData !== this.props.editingData) {     
      let formIsValid = false;      
      let updatedForm = POST_FORM;
      if (Object.keys(this.props.editingData).length !== 0) {    
        for (const inputName in updatedForm) {
           updatedForm[inputName].value = this.props.editingData[inputName];
           updatedForm[inputName].valid = true;
           updatedForm[inputName].touched = true;
        }
        formIsValid = true;
      }else{
        for (const inputName in updatedForm) {
          updatedForm[inputName].value = "";
          updatedForm[inputName].valid = false;
          updatedForm[inputName].touched = false;          
          updatedForm[inputName].errorMessage = "";
        }
      }
      this.setState({
        postForm: updatedForm,
        formIsValid: formIsValid,
      });
    }
  }

  postInputChangeHandler = (input, value, files) => {
    this.setState((prevState) => {
      let isValid = true;
      let errorMessage = "";
      for (const validator of prevState.postForm[input].validators) {
        isValid = isValid && validator(value).hasError;
        errorMessage = !isValid && errorMessage === "" ? validator(value).errorMessage : errorMessage;
      }
      const updatedForm = {
        ...prevState.postForm,
        [input]: {
          ...prevState.postForm[input],
          valid: isValid,
          errorMessage: errorMessage,
          value: value,
        },
      };
      let formIsValid = true;
      for (const inputName in updatedForm) {
        formIsValid = formIsValid && updatedForm[inputName].valid;
      }

      return {
        postForm: updatedForm,
        formIsValid: formIsValid,
        loading: false,
      };
    });
  };

  inputBlurHandler = (input) => {
    this.setState((prevState) => {
      return {
        postForm: {
          ...prevState.postForm,
          [input]: {
            ...prevState.postForm[input],
            touched: true,
          },
        },
      };
    });
  };
//////////////////////////////////////////////////////////////////////////////////////////
  cancelPostChangeHandler = () => {
    this.setState(
      {
        postForm: POST_FORM,
        formIsValid: false,
      });
    // this.props.onCancelEdit();
    this.props.toggleClass();
  };

  acceptPostChangeHandler = () => {
    if (this.state.formIsValid) {
      const post = {
        title: this.state.postForm.title.value,
        sort: this.state.postForm.sort.value,
        categoryCode: 0,

        //label: this.props.label,
        editingCode: this.props.editingData.id || 0,
      };
      
      this.props.onAcceptModal(post);

      let updatedForm = POST_FORM;
      for (const inputName in updatedForm) {
        updatedForm[inputName].value = "";
        updatedForm[inputName].valid = false;
        updatedForm[inputName].touched = false;          
        updatedForm[inputName].errorMessage = "";
      }

      this.setState({
        postForm: updatedForm,
        formIsValid: false,
        imagePreview: null,
      });
    } else {
      this.setState((prevState) => {
        let updatedForm = { ...prevState.postForm };

        for (const inputName in prevState.postForm) {
          let isValid = true;
          let errorMessage = "";
          for (const validator of prevState.postForm[inputName].validators) {
            isValid =
              isValid &&
              validator(prevState.postForm[inputName].value).hasError;
            errorMessage =
              !isValid && errorMessage === ""
                ? validator(prevState.postForm[inputName].value).errorMessage
                : errorMessage;
          }
          updatedForm = {
            ...updatedForm,
            [inputName]: {
              ...updatedForm[inputName],
              valid: isValid,
              errorMessage: errorMessage,
            },
          };
        }

        return {
          postForm: updatedForm,
        };
      });
    }
  };

  render() {
    return (
      <Fragment>
        <div className="mn-grid__col mn-grid__col--sm-6 mn-grid__col--lg-10 uk-padding-remove-left uk-padding-remove-right">
          <div className="mn-RD-profile__add-doc uk-width-1-1">
            <span className="uk-width-1-1 uk-text-right mn-brand-profile__add-doc-title">
              بارگذاری اطلاعات جدید
            </span>
            <form onSubmit={e => { e.preventDefault(); }}>
              <div className="mn-grid__row mn-grid__row--gap-lg mn-size_bp">
                  <div className="mn-grid__col mn-grid__col--gap-lg mn-grid__col--flex-initial mn-grid__col--lg-6">
                      <Input 
                          id="title"
                          label={"نام سایز:"}
                          placeholder={"نام سایز را وارد کنید …"}
                          type="text"
                          control="input"
                          required="required"
                          onChange={this.postInputChangeHandler}
                          onBlur={this.inputBlurHandler.bind(this, "title")}
                          valid={this.state.postForm["title"].valid}
                          touched={this.state.postForm["title"].touched}
                          value={this.state.postForm["title"].value || ""}
                          validationError={
                              !this.state.valid &&
                              this.state.postForm["title"].errorMessage
                          }
                      />
                  </div>
                  <div className="mn-grid__col mn-grid__col--gap-lg mn-grid__col--flex-initial mn-grid__col--lg-6 mn-grid__col--sm-gap">
                      <Input
                          id="sort"
                          label={"ترتیب نمایش:"}
                          placeholder={"ترتیب نمایش در خروجی …"}
                          type="text"
                          control="input"
                          required="required"
                          onChange={this.postInputChangeHandler}
                          onBlur={this.inputBlurHandler.bind(this, "sort")}
                          valid={this.state.postForm["sort"].valid}
                          touched={this.state.postForm["sort"].touched}
                          value={this.state.postForm["sort"].value || ""}
                          validationError={
                          !this.state.valid &&
                          this.state.postForm["sort"].errorMessage
                          }
                      />
                  </div>
              </div>
            </form>
            <div className="uk-flex uk-flex-right uk-flex-bottom">
              <Button
                design="next"
                mode=""
                type="submit"
                loading={false}
                onClick={this.acceptPostChangeHandler}
              >
                {!this.props.isEditing ? "ثبت و بارگذاری" : "ویرایش و بارگذاری"}
              </Button>
              <Button
                design="reset"
                mode=""
                type="submit"
                loading={false}
                onClick={this.cancelPostChangeHandler}
              >
                {}
              </Button>
            </div>
          </div>
        </div>                        
      </Fragment>
    );
  }
}
export default SizeForm;
